import { $qs, $qsa } from "./utils/QuerySelector";
import twkScroll from "./animations/twkScrollAnimations";
import homeAnimation from "./animations/home-banner";
import homeAnimationSecondary from "./animations/home-banner-secondary";
import growVideo from "./animations/grow-video";
import homeContentSlider from "./animations/home-content-slider";
//import homeSlider from "./animations/home-slider";
//import HorizontalScrollHome from "./animations/home-horizontal";
import initSVGLines from "./animations/svg-lines";
import onScroll from "./animations/onScroll";
import pageBanner from "./animations/page-banner";
import singleBanner from "./animations/single-banner";
import animate404 from "./animations/404-banner";
import { CountUp } from 'countup.js';


function init() {
  twkScroll();
  onScroll();
  if ($qs("body.page-template-tpl-home")) homeAnimation();
  //if ($qs("body.page-template-tpl-home")) homeAnimationSecondary();
  if ($qs("body.page-template-tpl-home")) growVideo();
  if ($qs("body.page-template-tpl-landing-page")) growVideo();
  if ($qs("body.page-template-tpl-home")) homeContentSlider();
  if ($qs(".error404")) animate404();
  if ($qs(".banner--media")) pageBanner();
  if ( $qs(".banner--single") || $qs('.banner--news') ) {
    singleBanner();
  } 
  if ( $qs("body.page-template-tpl-home") || $qs('body.page-template-tpl-landing-page') || $qs('body.page-template-tpl-admissions') ) {
    initSVGLines();
  }
  
  //if ($qs("body.page-template-tpl-home")) HorizontalScrollHome();
}
init();



jQuery(document).ready(function ($) {
  consoleMessage: {
    console.log(
      "%cCreated by %cTWK%cwww.thewebkitchen.co.uk",
      "background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;",
      "background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;",
      "background: #FFFFFF; padding: 5px 10px;"
    );
  }

  modernizer: {
    if (!Modernizr.objectfit) {
      $(".object-fit").each(function () {
        var $container = $(this),
          imgUrl = $container.find("img").prop("src");
        if (imgUrl) {
          $container
            .css("backgroundImage", "url(" + imgUrl + ")")
            .addClass("not-compatible");
        }
      });
    }
  }

  fixedheader: {
    $(function () {
      $(window).scroll(function () {
        if ($(window).scrollTop() >= 150) {
          $(".header").addClass("fixed-header");
        }
        if ($(window).scrollTop() >= 160) {
          $(".header").addClass("transform-none");
        } else {
          $(".header").removeClass("fixed-header");
          $(".header").removeClass("transform-none");
        }
      });
    });
  }

  search: {
    $(".js-search-open").on("click", function (e) {
      $(this).toggleClass("open"); 
      $(".search-form").toggleClass("search-open");
      $(".search-open").toggleClass("search-closed");
      $(".menu-search-overlay").toggleClass("open");
    });
    /*
    $(".search-icon").on("click", function (e) {
      $(".searchform").toggleClass("search-open");
      $(this).toggleClass("submit-zindex");
      $(".select-lang").removeClass("transform-height");
      $("#menu-main-menu-top, .lang_dropdown").fadeOut();
      $("#s").focus();
      setTimeout(function () {
        $(".close-search").fadeIn();
      }, 300);
    });
    $(".close-search").on("click", function (e) {
      $(this).fadeOut();
      $(".searchform").removeClass("search-open");
      $(".search-icon").removeClass("submit-zindex");
      $("#menu-main-menu-top, .lang_dropdown").fadeIn();
    });
    */
  }

  menu: {
    const hamburger = document.querySelector(".hamburger");
    const menuWrapper = document.querySelector(".menu-wrapper");
    const menuItemsChildren = document.querySelectorAll("#main-menu > li > a");
    const subMenus = document.querySelectorAll(".sub-menu-wrap");
    const menuImg = document.querySelector(".menu-wrapper__images");
    const backButton = document.querySelectorAll(".back-button");

    let menuState = false;

    const closeSubMenus = () => {
      subMenus.forEach((item) => {
        item.classList.remove("sub-menu-wrap--open");
      });
    };

    const changeHamburgerState = () => {
      const hamburgerText = document.querySelector(".hamburger__text");
      if (hamburgerText.innerText === "MENU") {
        hamburgerText.innerText = "CLOSE";
        hamburger.classList.add("hamburger--open");

        if (hamburgerText.classList.contains("hamburger--closed")) {
        }

        // Menu fade out
        //hamburgerText.classList.add('text-fade-out');
        //hamburgerText.classList.remove('text-fade-in');
      } else {
        hamburgerText.innerText = "MENU";
        hamburger.classList.remove("hamburger--open");

        // Close fade out
        //hamburgerText.classList.add('text-fade-out');
        //hamburgerText.classList.remove('text-fade-in');
      }
    };

    hamburger.addEventListener("click", () => {
      if (!menuState) {
        changeHamburgerState();
        menuWrapper.classList.add("menu-wrapper--open");
        menuState = true;

        /*
        menuItemsChildren.forEach((item) => {
          if (item.parentElement.classList.contains("current-page-ancestor")) {
            //menuImg.classList.add('open-image');
            menuWrapper.classList.add("sub-menu--open");
            item.parentElement.childNodes[2].classList.add(
              "sub-menu-wrap--open"
            );
          }
        });
        */
      } else {
        closeSubMenus();
        changeHamburgerState();
        //menuImg.classList.remove('open-image');
        menuWrapper.classList.remove("menu-wrapper--open");
        menuState = false;
      }
    });
    backButton.forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        closeSubMenus();
      });
    });

    menuItemsChildren.forEach((item) => {
      item.addEventListener("click", function (e) {
        //e.preventDefault();
        closeSubMenus();
        //menuImg.classList.add('open-image');
        //menuWrapper.classList.add("sub-menu--open");
        //item.parentElement.childNodes[2].classList.add("sub-menu-wrap--open");
      });
    });
  }

  anchorlinks: {
    $(document).on("click", ".scroll-to", function (event) {
      event.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top,
        },
        500
      );
    });
  }

  externallinks: {
    $('a[href^="mailto:"]').each(function () {
      $(this).addClass("email-link");
    });

    $('a:not(.email-link):not([class^="magnific-"])').each(function () {
      var a = new RegExp("/" + window.location.host + "/");

      if (!a.test(this.href)) {
        $(this).click(function (event) {
          event.preventDefault();
          window.open(this.href, "_blank");
        });
      }
    });
    pdfs: {
      // Open PDFs in new window
      $(function () {
        $('a[href$=".pdf"]').prop("target", "_blank");
      });
    }
  }

  slider: {
    $(".full-width-slider").each(function () {
      var slider = $(this);

      slider.slick({
        dots: false,
        arrows: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3500,
        speed: 1200,
        nextArrow: slider.parent().find(".slider-nav__next"),
        prevArrow: slider.parent().find(".slider-nav__prev"),
      });
    });

    $(".js-slider-dots-arrows").each(function () {
      var slider = $(this);

      slider.slick({
        dots: true,
        arrows: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3500,
        speed: 1200,
        prevArrow: slider.parent().parent().find(".slider-nav__prev"),
        nextArrow: slider.parent().parent().find(".slider-nav__next"),
        appendDots: slider.parent().parent().find(".slider-dots-container"),
      });
    });

    /*
    $(".logo-slider").slick({
      dots: false,
      arrows: false,
      fade: false,
      autoplay: false,
      autoplaySpeed: 3500,
      speed: 1200,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '37%',
      infinite: true,
    });
    */

    /**
     * Gallery slider with thumbnails navigation.
     */
    $(".gallery-slider").each(function (index) {
      var status = $(this).find(".gallery-slider__full-nav .pages");
      var slickElement = $(this).find(".gallery-slider__full");
      var slickElementThumb = $(this).find(".gallery-slider__thumb");

      slickElement.on(
        "init reInit afterChange",
        function (event, slick, currentSlide, nextSlide) {
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          var i = (currentSlide ? currentSlide : 0) + 1;
          status.text(i + " of " + slick.slideCount);
        }
      );

      slickElement.slick({
        dots: false,
        arrows: true,
        fade: true,
        asNavFor: $(this).find(".gallery-slider__thumb"),
        appendArrows: $(this).find(".gallery-slider__full-nav"),
      });

      slickElementThumb.slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        // centerMode: true,
        focusOnSelect: true,
        asNavFor: $(this).find(".gallery-slider__full"),
      });
    });
  }

  magnific: {
    // IFRAME
    $(".magnific-video").magnificPopup({
      type: "iframe",
      mainClass: "mfp-video-wrapper",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,

      iframe: {
        markup:
          '<div class="mfp-iframe-scaler">' +
          '<div class="mfp-close"></div>' +
          '<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
          "</div>",
        patterns: {
          youtu: {
            index: "youtu.be",
            id: function (url) {
              // Capture everything after the hostname, excluding possible querystrings.
              var m = url.match(/^.+youtu.be\/([^?]+)/);

              if (null !== m) {
                return m[1];
              }

              return null;
            },
            // Use the captured video ID in an embed URL.
            // Add/remove querystrings as desired.
            src: "//www.youtube.com/embed/%id%?autoplay=1&rel=0",
          },
          youtube: {
            index: "youtube.com/",
            id: "v=",
            src: "https://www.youtube.com/embed/%id%?autoplay=1",
          },
        },
      },
    });

    // INLINE
    $(".magnific-inline-popup").magnificPopup({
      type: "inline",

      fixedContentPos: false,
      fixedBgPos: true,

      overflowY: "auto",

      closeBtnInside: true,
      preloader: false,

      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in",
    });

    // GALLERY SINGLE IMAGE
    $(".magnific-gallery-single-image").magnificPopup({
      type: "image",
      closeOnContentClick: true,
      mainClass: "mfp-img-single",
      image: {
        verticalFit: true,
        titleSrc: function titleSrc(item) {
          return item.el.attr("title");
        },
      },
      gallery: {
        enabled: false,
      },
    });

    // GALLERY IMAGE
    $(".magnific-gallery-image").magnificPopup({
      type: "image",
      closeOnContentClick: true,
      mainClass: "mfp-img-mobile",
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return item.el.attr("title");
        },
      },
      gallery: {
        enabled: true,
      },
    });
  }

  bannerImages: {
    function calcBannerWidth() {
      var bannerOffset = $(".banner--media .col-md-7").offset();
      var temp = 50;
      var columnWidth = $(".banner--media .col-md-7").width();
      var bannerWidth = columnWidth + bannerOffset.left + temp;
      $(".banner--media .banner__image").css("width", bannerWidth);
    }

    if (
      $("body").hasClass("page-template-default") ||
      $("body").hasClass("page-template-tpl-landing-page") ||
      $("body").hasClass("page-template-tpl-staff") ||
      $("body").hasClass("page-template-tpl-admissions") ||
      $("body").hasClass("page-template-tpl-online-joining") ||
      $("body").hasClass("page-template-tpl-headmaster-blog") ||
      $("body").hasClass("page-template-tpl-cookies") ||
      $("body").hasClass("page-template-tpl-calendar") ||
      $("body").hasClass("archive")
    ) {
      calcBannerWidth();
      $(window).resize(function () {
        calcBannerWidth();
      });
    }
  }

  teaserHover: {
    if (window.matchMedia("(min-width: 992px)").matches) {
      $(".teaser-item--1").on("mouseenter", function (e) {
        $(".teaser-item--2").addClass("hover");
        $(".teaser-item--3").addClass("hover");
      });
      $(".teaser-item--1").on("mouseleave", function (e) {
        $(".teaser-item--2").removeClass("hover");
        $(".teaser-item--3").removeClass("hover");
      });
      $(".teaser-item--2").on("mouseenter", function (e) {
        $(".teaser-item--3").addClass("hover");
      });
      $(".teaser-item--2").on("mouseleave", function (e) {
        $(".teaser-item--3").removeClass("hover");
      });
    }
  }

  scrollTabs: {
    $(window).scroll(function () {
      var scrollTop = $(document).scrollTop();
      var anchors = $("body").find(".step");
      var panelOne = "panel-1";
      changeClassesOnScroll();

      function changeClassesOnScroll() {
        for (var i = 0; i < anchors.length; i++) {
          if (
            scrollTop > $(anchors[i]).offset().top - 170 &&
            scrollTop <
              $(anchors[i]).offset().top + $(anchors[i]).height() - 170
          ) {
            $('.step-link[href="#' + $(anchors[i]).attr("id") + '"]')
              .parent()
              .addClass("current_page_item");
            $("#" + $(anchors[i]).attr("id")).addClass("active");
            $("#" + $(anchors[i]).attr("id"))
              .find(".step__dot")
              .addClass("show");
          } else if (scrollTop < $("#" + panelOne).offset().top) {
            $('.step-link[href="#' + panelOne)
              .parent()
              .addClass("current_page_item");
            $("#" + panelOne).addClass("active");
            $("#" + panelOne)
              .find(".step__dot")
              .addClass("show");
          } else {
            $('.step-link[href="#' + $(anchors[i]).attr("id") + '"]')
              .parent()
              .removeClass("current_page_item");
            $("#" + $(anchors[i]).attr("id")).removeClass("active");
            $("#" + $(anchors[i]).attr("id"))
              .find(".step__dot")
              .removeClass("show");
          }
        }
      }
    });
  }

  tables: {
    $(".tablepress").wrap('<div class="table-wrapper"></div>');
    $(".block--text-area table").wrap('<div class="table-wrapper"></div>');
  }

  customDropdown: {
    $(".js-dropdown").on("click", function (e) {
      if ($(".js-dropdown").hasClass("active")) {
        $(".js-dropdown").removeClass("active");
      } else {
        $(".js-dropdown").addClass("active");
      }
    });
  }

  accordion: {
    if ($(".block--accordion").length) {
      // Close accordions on all pages except staff page
      if (!$("body").hasClass("page-template-tpl-staff")) {
        $(".accordion__content--wrapper").css("display", "none"); // All items closed.
      }

      $(".block--accordion")
        .find(".js-accordion-trigger")
        .on("click", function () {
          console.log("accordion");

          // Close only the items in this accordion.
          $(this)
            .parent()
            .siblings()
            .find(".js-accordion-trigger")
            .next()
            .slideUp("fast"); // reset
          $(this)
            .parent()
            .siblings()
            .find(".js-accordion-trigger")
            .removeClass("open"); // reset


          if ($(this).hasClass("open")) {
            $(this).next().slideUp("fast");
            $(this).removeClass("open");
            console.log("closed");
          } else {
            $(this).next().slideDown("fast");
            $(this).addClass("open");
            console.log("opened");
          }
        });
    }
  }
  
  statCountUps: {

    if ( $('.block--intro-statistics').length || $('.block--statistics').length ) {
      const statOne = $('#stat-1').data('number');
      let statOneSuffix = $('#stat-1').data('suffix');
      if ( !statOneSuffix ) { statOneSuffix = ''; } 
      const countUpOne = new CountUp('stat-1', statOne, { enableScrollSpy: true, suffix: statOneSuffix });
  
      const statTwo = $('#stat-2').data('number');
      let statTwoSuffix = $('#stat-2').data('suffix');
      if ( !statTwoSuffix ) { statTwoSuffix = ''; }
      const countUpTwo = new CountUp('stat-2', statTwo, { enableScrollSpy: true, suffix: statTwoSuffix });
  
      const statThree = $('#stat-3').data('number');
      let statThreeSuffix = $('#stat-3').data('suffix');
      if ( !statThreeSuffix ) { statThreeSuffix = ''; }
      const countUpThree = new CountUp('stat-3', statThree, { enableScrollSpy: true, suffix: statThreeSuffix });
    }

    if ( $('.block--text-statistic').length ) {
      const statTextOne = $('#stat-text-1').data('number');
      let statTextOneSuffix = $('#stat-text-1').data('suffix');
      if ( !statTextOneSuffix ) { statTextOneSuffix = ''; } 
      const countUpTextOne = new CountUp('stat-text-1', statTextOne, { enableScrollSpy: true, suffix: statTextOneSuffix });
    }

  }

  loadingAnimations: {
    $.fn.isOnScreen = function () {
      var win = $(window);
      var viewport = {
        top: win.scrollTop(),
      };
      viewport.bottom = viewport.top + win.height() - 80;

      var bounds = this.offset();
      bounds.bottom = bounds.top + this.outerHeight();

      return !(viewport.bottom < bounds.top || viewport.top > bounds.bottom);
    };

    // First load Animation
    $(".off-screen").each(function (index) {
      if ($(this).isOnScreen()) {
        $(this).removeClass("off-screen--hide");
      }
    });

    // Animation on scroll
    $(window).scroll(function () {
      $(".off-screen").each(function (index) {
        if ($(this).isOnScreen()) {
          $(this).removeClass("off-screen--hide");
        }
      });
    });
  }
});
